import {
	PlayerAccountApi,
	RecentlyPlayedGame,
} from '../../communication/player-account/PlayerAccountApi'

export enum RecentlyPlayedActionTypes {
		GET_RECENTLY_PLAYED_STARTED = 'GET_RECENTLY_PLAYED_STARTED',
		GET_RECENTLY_PLAYED_SUCCESS = 'GET_RECENTLY_PLAYED_SUCCESS',
		GET_RECENTLY_PLAYED_FAILURE = 'GET_RECENTLY_PLAYED_FAILURE',
		UPDATE_RECENTLY_PLAYED_STARTED = 'UPDATE_RECENTLY_PLAYED_STARTED',
		UPDATE_RECENTLY_PLAYED_SUCCESS = 'UPDATE_RECENTLY_PLAYED_SUCCESS',
		UPDATE_RECENTLY_PLAYED_FAILURE = 'UPDATE_RECENTLY_PLAYED_FAILURE'
}

export type PlayerItemAction =
    | { type: RecentlyPlayedActionTypes.GET_RECENTLY_PLAYED_STARTED }
    | { type: RecentlyPlayedActionTypes.GET_RECENTLY_PLAYED_SUCCESS; payload: { recentlyPlayedGameItems: RecentlyPlayedGame[] } }
    | { type: RecentlyPlayedActionTypes.GET_RECENTLY_PLAYED_FAILURE; payload: { error: Error } }
		| { type: RecentlyPlayedActionTypes.UPDATE_RECENTLY_PLAYED_STARTED }
		| { type: RecentlyPlayedActionTypes.UPDATE_RECENTLY_PLAYED_SUCCESS; payload: { recentlyPlayedGameItems: RecentlyPlayedGame[] } }
		| { type: RecentlyPlayedActionTypes.UPDATE_RECENTLY_PLAYED_FAILURE; payload: { error: Error } }

const getRecentlyPlayedStarted = () => ({
	type: RecentlyPlayedActionTypes.GET_RECENTLY_PLAYED_STARTED,
})

const getRecentlyPlayedSuccess = (recentlyPlayedGameItems: RecentlyPlayedGame[]) => ({
	type: RecentlyPlayedActionTypes.GET_RECENTLY_PLAYED_SUCCESS,
	payload: {
		recentlyPlayedGameItems,
	},
})

const getRecentlyPlayedFailure = error => ({
	type: RecentlyPlayedActionTypes.GET_RECENTLY_PLAYED_FAILURE,
	payload: {
		error,
	},
})


const updateRecentlyPlayedStarted = () => ({
	type: RecentlyPlayedActionTypes.UPDATE_RECENTLY_PLAYED_STARTED,
})

const updateRecentlyPlayedSuccess = (recentlyPlayedGameItems: RecentlyPlayedGame[]) => ({
	type: RecentlyPlayedActionTypes.UPDATE_RECENTLY_PLAYED_SUCCESS,
	payload: {
		recentlyPlayedGameItems,
	},
})

const updateRecentlyPlayedFailure = error => ({
	type: RecentlyPlayedActionTypes.UPDATE_RECENTLY_PLAYED_FAILURE,
	payload: {
		error,
	},
})


export const getRecentlyPlayedGames = () => dispatch => {
	dispatch(getRecentlyPlayedStarted())
	PlayerAccountApi.getRecentlyPlayedGames()
		.then(response => dispatch(getRecentlyPlayedSuccess(response.games)))
		.catch(error => dispatch(getRecentlyPlayedFailure(error)))
}

export const updateRecentlyPlayedGames = (gameId: string) => dispatch => {
	dispatch(updateRecentlyPlayedStarted())
	PlayerAccountApi.updateRecentlyPlayedGame(gameId)
		.then(response => dispatch(updateRecentlyPlayedSuccess(response.games)))
		.catch(error => dispatch(updateRecentlyPlayedFailure(error)))
}
